import Api from './api';

const invoiceContactDetailsListRequest = (userId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/contact/invoices?user_id=' + userId, {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const createInvoiceContactDetailsRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/contact/invoices/', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const deleteInvoiceContactDetailsRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/contact/invoice/' + id, { headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}


export default {
    invoiceContactDetailsListRequest,
    createInvoiceContactDetailsRequest,
    deleteInvoiceContactDetailsRequest
}



// WEBPACK FOOTER //
// ./src/api/apiInvoiceContactDetails.js